import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom";
import { getOfficeBySlug, offices } from "../../data/offices";
import Btn from "../Btn";
import "./styles.scss";

const Oficinas = () => {
	const location = useLocation();
	const history = useHistory();
	const shouldReduceMotion = useReducedMotion();
	const initialOffice = getOfficeBySlug(new URLSearchParams(location.search).get("oficina"));
	const [activeSlug, setActiveSlug] = useState(initialOffice.slug);
	const [isMapLoading, setIsMapLoading] = useState(true);
	const activeOffice = getOfficeBySlug(activeSlug);

	useEffect(() => {
		const officeSlug = new URLSearchParams(location.search).get("oficina");
		setActiveSlug(getOfficeBySlug(officeSlug).slug);
	}, [location.search]);

	useEffect(() => {
		setIsMapLoading(true);
	}, [activeSlug]);

	const cambiarOficina = (slug) => {
		setActiveSlug(slug);
		history.push(`/oficinas?oficina=${slug}`);
	};

	return (
		<section className="oficinas">
			<div className="oficinas_header">
				<p>DIRECTORIO / SEDES</p>
				<h1>Oficinas ForzaKargo</h1>
			</div>

			<div className="lista_oficinas" role="tablist" aria-label="Oficinas ForzaKargo">
				{offices.map((office) => (
					<button
						key={office.slug}
						type="button"
						role="tab"
						aria-selected={activeOffice.slug === office.slug}
						className={activeOffice.slug === office.slug ? "active" : ""}
						onClick={() => cambiarOficina(office.slug)}
					>
						{office.name}
					</button>
				))}
			</div>

			<div className="oficina_card">
				<AnimatePresence exitBeforeEnter>
					<motion.div
						key={activeOffice.slug}
						className="titulo_oficina"
						initial={shouldReduceMotion ? false : { opacity: 0, y: 16 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -10 }}
						transition={{ duration: 0.28, ease: "easeOut" }}
					>
						<div className="nombre_oficina">
							<span>FKG-{String(activeOffice.id).padStart(2, "0")} / Oficina activa</span>
							<h2>{activeOffice.name}</h2>
							<p>Atención logística para operaciones de carga nacional y conexión con corredores portuarios.</p>

							<div className="opciones_oficina">
								<Btn type="btn_email" funOnclick={() => history.push("/contacto")}>
									<FaEnvelope />
									E-mail
								</Btn>
								<Btn
									type="btn_whatapp"
									funOnclick={() => {
										window.open(
											"https://api.whatsapp.com/send?phone=573104477161&text=Hola! me llamo "
										);
									}}
								>
									<FaWhatsapp />
									Chatear
								</Btn>
							</div>
						</div>

						<div className="info_oficina">
							<div className="info_row">
								<FaMapMarkerAlt />
								<div>
									<h5>Dirección</h5>
									<p>{activeOffice.dir}</p>
								</div>
							</div>
							<div className="info_row">
								<FaPhoneAlt />
								<div>
									<h5>Teléfonos</h5>
									<ul>
										{activeOffice.tels.length > 0 ? (
											activeOffice.tels.map((tel) => <li key={tel}>{tel}</li>)
										) : (
											<li>Disponible por WhatsApp</li>
										)}
									</ul>
								</div>
							</div>
						</div>
					</motion.div>
				</AnimatePresence>

				<div className="ubicacion_shell">
					<div className="ubicacion_label">
						<span>MAPA EMBEBIDO</span>
						<strong>{activeOffice.shortName}</strong>
					</div>
					<div className="ubicacion_oficina">
						{isMapLoading ? <div className="map_skeleton" /> : null}
						<iframe
							key={activeOffice.slug}
							title={`Ubicación oficina ${activeOffice.shortName}`}
							src={activeOffice.urlMap}
							width="100%"
							height="100%"
							style={{ border: 0 }}
							allowFullScreen
							loading="lazy"
							onLoad={() => setIsMapLoading(false)}
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Oficinas;
